import styled from "@emotion/styled";
import { colors, GOI_PLATFORM_URL, customEvent } from "goi_common";

export const HomeHeroSection = () => {
  return (
    <HeroRoot>
      <HeroContent>
        <HeroTitle>
          전국 장례식장
          <br />
          정보 한눈에 확인
        </HeroTitle>
        <HeroSub>빈소 현황 · 비용 · 교통 안내 무료 제공</HeroSub>
        <HeroCTA
          onClick={() => {
            customEvent({
              newGtm: {
                path: "prlr_home",
                trigger_and_target: "hero-uv_mtch_rqst",
              },
            });
            window.location.href = `${GOI_PLATFORM_URL}/match/request/?utm_campaign=parlor`;
          }}
        >
          무료 장례 상담 받기 →
        </HeroCTA>
      </HeroContent>
    </HeroRoot>
  );
};

const HeroRoot = styled.section`
  width: 100%;
  background: linear-gradient(160deg, #fff7f0 0%, #fce8d5 55%, #f8d9bc 100%);
  padding: 36px 20px 32px;
  border-bottom: 1px solid #f0d9c4;
`;

const HeroContent = styled.div`
  max-width: 480px;
  margin: 0 auto;
`;

const HeroTitle = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: ${colors.gray900};
  line-height: 1.3;
  margin: 0 0 10px;
`;

const HeroSub = styled.p`
  font-size: 14px;
  color: ${colors.gray600};
  margin: 0 0 24px;
`;

const HeroCTA = styled.button`
  display: inline-block;
  background: ${colors.orange650};
  color: ${colors.white};
  font-size: 15px;
  font-weight: 600;
  padding: 13px 24px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: ${colors.orange700};
  }
`;
